// THIS IS A GENERATED FILE. DO NOT EDIT
// Generated from Shared/Analytics/mixpanel_structure.yaml by
// Shared/Analytics/generate_mixpanel_structure.py. Edit the YAML, rerun the script, and
// commit both.
import {type GeneratedAnalyticsEvent, type GeneratedAnalyticsProperties} from './generatedEventTypes'
import {analyticsFormat, type NoteIdValue, type DurationSecondsValue} from './analyticsFormat'

const analyticsTypeWires: {
  // UUID, uppercase, hyphenated
  readonly noteId: (value: NoteIdValue) => string
  // seconds
  readonly durationSeconds: (value: DurationSecondsValue) => number
} = {
  noteId: analyticsFormat.noteId,
  durationSeconds: analyticsFormat.durationSeconds,
}

export type HyperlinkKind = 'Note' | 'Web'

export type HyperlinkSource = 'Selection Toolbar' | 'Keyboard Shortcut' | 'Link Click' | 'Context Menu'

export type HyperlinkTargetSource = 'Recents' | 'Search' | 'URL' | 'Unchanged'

export type LearnContentReportReason = 'Inappropriate' | 'Irrelevant' | 'Incorrect' | 'Email Us'

export type SignInProvider =
  | 'Google'
  | 'Apple'
  | 'Microsoft'
  | 'Password'
  | 'Magic Link'
  | 'Passkey'
  | 'Business Invite'
  | 'Exempt due to excluded region'
  | 'Unknown'

export type SignInResult =
  | 'Success'
  | 'Failure'
  | 'Cancel'
  | 'Dismiss for VPP or MDM'
  | 'Sign in skipped for China user'

export type OnboardingStep = 'Sign Up' | 'Join Business' | 'Persona' | 'Story' | 'Calendar' | 'Microphone'

export type OnboardingStepPersona = 'Student' | 'Professional' | 'Other'

export type OnboardingStepAction =
  | 'Select Persona'
  | 'Show Me How'
  | 'Connect Calendar'
  | 'No Calendar'
  | 'Later'
  | 'Upload Syllabus'
  | 'Allow Microphone'
  | 'Allow System Audio'
  | 'Restart'
  | 'Request To Join'
  | 'Dismiss'

export type OnboardingStepResult = 'Connected' | 'Cancelled' | 'Failed' | 'Granted' | 'Denied' | 'Sent'

export type RecordingEventSource =
  | 'Top Toolbar Record Button'
  | 'Learn Tray'
  | 'Get Started Record'
  | 'Home Screen Record'
  | 'Calendar'
  | 'Meeting Notification'
  | 'Command'
  | 'Widget'
  | 'Note View Menu Shortcut'
  | 'Campaign'
  | 'Home Top Bar Record'
  | 'Folder Page Record'
  | 'App Menu'
  | 'Hotkey'
  | 'Backup Recovery'
  | 'Recording Cue Card'

export type FlashcardRatingName = 'Again' | 'Hard' | 'Medium' | 'Easy'

export type MeetingNotificationTrigger = 'Scheduled' | 'Unscheduled' | 'Reminder'

export type MeetingNotificationDecider = 'User' | 'Model' | 'Rule'

export type StartEventNoteTrigger = 'Home Card' | 'Notification' | 'Widget' | 'Unknown'

export type CalendarToggleSource = 'Device' | 'Microsoft' | 'Google' | 'Apple' | 'Calendar Link' | 'None'

export type CalendarConnectEventSource = 'Calendar Gate' | 'Home Screen' | 'Settings' | 'Syllabus Import'

export type CalendarLinkSource =
  | 'Home Unlock Card'
  | 'Home Empty State'
  | 'Syllabus Import'
  | 'Connected Services'
  | 'Onboarding Calendar Connect'

export type CalendarLinkResult = 'Connected' | 'Failed' | 'Cancelled'

export type CalendarLinkFailureReason = 'Invalid URL' | 'Not A Calendar' | 'Feed Unavailable' | 'Network'

export type CalendarProvider = 'Google' | 'Microsoft' | 'Apple' | 'Calendar Link' | 'Device'

export type CalendarConsentScope = 'Readonly' | 'Events And List' | 'Events'

export type CalendarListStatus = 'Ok' | 'Scope Not Granted' | 'Failed'

export type CalendarListScope = 'Granted' | 'Not Requested' | 'Declined'

export type CalendarHandoffFailReason =
  | 'Scope Declined'
  | 'Timeout'
  | 'Browser Not Opened'
  | 'Dismissed'
  | 'Denied'
  | 'Account Mismatch'
  | 'Failed'

export type SyncCalendarOutcome = 'Success' | 'Auth' | 'Transient' | 'Disconnected' | 'Scope Declined'

export type SyncCalendarSource = 'Coming Up Menu' | 'Coming Up Retry'

export type CalendarConnectCardReason = 'Not Connected' | 'Reconsent'

export type CalendarErrorCardKind = 'Load Failed' | 'Auth' | 'Scope Declined'

export type CalendarGateSkipReason = 'No Calendar Sso' | 'Connect Error' | 'Calendar Sso'

export type CalendarGateStage = 'Connect' | 'Loading' | 'No Events' | 'Connect Failed' | 'Add Events'

export type CalendarCueCard = 'General' | 'Record'

export type DismissCalendarCueCardSource = 'Got It' | 'Record' | 'Meeting Notification'

export type MeetingNotificationDismissReason = 'Dismissed' | 'Timeout' | 'Muted'

export type MeetingNotificationMuteReason = 'Cant Record' | 'No Notes Needed'

export type MeetingNotificationToggleSource = 'Manage Events' | 'Coming Up Row' | 'Meeting Card'

export type MeetingNotificationMissReason =
  | 'App Closed'
  | 'Window Closed'
  | 'Note Open'
  | 'Card On Screen'
  | 'Grace Period'

export type DesktopLifecycle =
  | 'Foreground'
  | 'Blurred'
  | 'Hidden'
  | 'Asleep'
  | 'Closing'
  | 'Quitting'
  | 'Locked'
  | 'No Window'

export type RecordingStopReason =
  | 'User'
  | 'Inactivity'
  | 'Meeting Ended'
  | 'Handoff'
  | 'Note Access Revoked'
  | 'Note Deleted'
  | 'Logout'
  | 'Shutdown'
  | 'Recorder Error'

export type RecordingMode = 'Basic' | 'Live Transcription'

export type CalendarHomeCopyVariant = 'Autopilot'

export type CustomCalendarEventSource = 'Calendar Gate' | 'Home Screen'

export type AiApp = 'Claude' | 'ChatGPT'

export type AiAppConnectionEventSource = 'Settings'

export type CalendarHandoffAttempt = {
  handoffId: string | null
  handoffAttempt: number | null
}

export function calendarHandoffAttemptProperties(params: CalendarHandoffAttempt): GeneratedAnalyticsProperties {
  return {
    ...(params.handoffId === null ? {} : {'Handoff Id': params.handoffId}),
    ...(params.handoffAttempt === null ? {} : {'Handoff Attempt': params.handoffAttempt}),
  }
}

export type CalendarEventShape = {
  eventIsRecurring: boolean
  captureEligible: boolean
  attendeeCountBucket: string
  hasMeetingLink: boolean
  durationBucket: string
}

export function calendarEventShapeProperties(params: CalendarEventShape): GeneratedAnalyticsProperties {
  return {
    'Event Is Recurring': params.eventIsRecurring,
    // The capture card's own rule — a meeting, or an event in a recurring class.
    'Capture Eligible': params.captureEligible,
    // 0 | 1 | 2to5 | 6+
    'Attendee Count Bucket': params.attendeeCountBucket,
    'Has Meeting Link': params.hasMeetingLink,
    // <=30m | 31to60m | 61to120m | >120m
    'Duration Bucket': params.durationBucket,
  }
}

/**
 * A historical row tapped in the version-history panel. Locked rows are tracked too (Is Locked = true, then the upsell
 * shows) to measure how often users reach versions beyond their tier window; the current-version row is untracked.
 */
export function viewNoteVersion(params: {
  noteId: NoteIdValue
  isLocked: boolean
}): GeneratedAnalyticsEvent<'View Note Version'> {
  return {
    name: 'View Note Version',
    properties: {
      'Note Id': analyticsTypeWires.noteId(params.noteId),
      'Is Locked': params.isLocked,
      'Source': 'Version History',
    },
  }
}

/**
 * A link is saved from the text link editor: iOS's link sheet, web's link popover. Fires for web links and note links,
 * new and edited.
 */
export function insertHyperlink(params: {
  kind: HyperlinkKind
  isEditing: boolean
  source: HyperlinkSource
  targetSource: HyperlinkTargetSource | null
}): GeneratedAnalyticsEvent<'Insert Hyperlink'> {
  return {
    name: 'Insert Hyperlink',
    properties: {
      'Kind': params.kind,
      // True when the editor opened on an existing link.
      'Is Editing': params.isEditing,
      'Source': params.source,
      // Absent for a web link.
      ...(params.targetSource === null ? {} : {'Target Source': params.targetSource}),
    },
  }
}

/**
 * The like button on a Chat Across Your Notes reply is pressed, once per mounted reply. A second press on an
 * already-liked reply sends nothing.
 */
export function likeLearnContent(params: {
  noteId: NoteIdValue | null
}): GeneratedAnalyticsEvent<'Like Learn Content'> {
  return {
    name: 'Like Learn Content',
    properties: {
      'Type': 'Notes Chatbot',
      // Full-screen chat sends the note it was launched from and the in-note tray sends the note it shows. Absent for a
      // chat launched from Home or a folder.
      ...(params.noteId === null ? {} : {'Note Id': analyticsTypeWires.noteId(params.noteId)}),
    },
  }
}

/**
 * A reason is picked from the report menu on a Chat Across Your Notes reply. Opening and dismissing the menu sends
 * nothing.
 */
export function reportedContent(params: {
  noteId: NoteIdValue | null
  reason: LearnContentReportReason
}): GeneratedAnalyticsEvent<'Reported Content'> {
  return {
    name: 'Reported Content',
    properties: {
      'Type': 'Notes Chatbot',
      // Full-screen chat sends the note it was launched from and the in-note tray sends the note it shows. Absent for a
      // chat launched from Home or a folder.
      ...(params.noteId === null ? {} : {'Note Id': analyticsTypeWires.noteId(params.noteId)}),
      'Reason': params.reason,
    },
  }
}

/**
 * Fires on a change from closed or from the saved view into the insert or edit view. While the editor is already open,
 * nothing fires.
 */
export function openHyperlinkEditor(params: {
  source: HyperlinkSource
  isEditing: boolean
}): GeneratedAnalyticsEvent<'Open Hyperlink Editor'> {
  return {
    name: 'Open Hyperlink Editor',
    properties: {
      'Source': params.source,
      // True when the editor opens on an existing link.
      'Is Editing': params.isEditing,
    },
  }
}

/**
 * A note link opens its target note, after the client confirms the note exists. A link to a missing note fires nothing.
 */
export function openHyperlink(): GeneratedAnalyticsEvent<'Open Hyperlink'> {
  return {
    name: 'Open Hyperlink',
    properties: {
      'Kind': 'Note',
    },
  }
}

/** The version-history panel is opened from the note-options menu. */
export function openVersionHistory(params: {
  noteId: NoteIdValue
}): GeneratedAnalyticsEvent<'Open Version History'> {
  return {
    name: 'Open Version History',
    properties: {
      'Note Id': analyticsTypeWires.noteId(params.noteId),
    },
  }
}

/**
 * Undo tapped on the banner shown after a version restore. Note Id is the original (source) note the copy was restored
 * from, not the restored copy being deleted.
 */
export function undoRestore(params: {
  noteId: NoteIdValue
}): GeneratedAnalyticsEvent<'Undo Restore'> {
  return {
    name: 'Undo Restore',
    properties: {
      'Note Id': analyticsTypeWires.noteId(params.noteId),
      'Source': 'Version History',
    },
  }
}

/**
 * The open-original button tapped on the banner shown after a version restore. Note Id is the original (source) note
 * the copy was restored from.
 */
export function openOriginalNote(params: {
  noteId: NoteIdValue
}): GeneratedAnalyticsEvent<'Open Original Note'> {
  return {
    name: 'Open Original Note',
    properties: {
      'Note Id': analyticsTypeWires.noteId(params.noteId),
      'Source': 'Version History',
    },
  }
}

/**
 * A recording ends (iOS also fires on its no-active-recording error path). iOS arms a Mixpanel timed event at recording
 * start, so the SDK adds `$duration` (wall-clock seconds start to end) beside Recording Duration; web arms the same
 * timer via timeAnalyticsEvent.
 */
export function recordAudio(params: {
  recordingDuration: DurationSecondsValue
  noteId: NoteIdValue | null
  eventSource: RecordingEventSource | null
  summaryVisible: boolean
  lowVolumeWarnCount: number | null
  lowVolumeErrorCount: number | null
  lowVolumeErrorDismissCount: number | null
  codec: string | null
  stopReason: RecordingStopReason | null
  boundMeetingApp: string | null
  trigger: MeetingNotificationTrigger | null
}): GeneratedAnalyticsEvent<'Record Audio'> {
  return {
    name: 'Record Audio',
    properties: {
      'Recording Duration': analyticsTypeWires.durationSeconds(params.recordingDuration),
      // iOS omits the key when the recording library has no note id; Android always has one.
      ...(params.noteId === null ? {} : {'Note Id': analyticsTypeWires.noteId(params.noteId)}),
      ...(params.eventSource === null ? {} : {'Event Source': params.eventSource}),
      // The note's Smart Notes tab was on screen in the Learn tray when the recording was saved.
      'Summary Visible': params.summaryVisible,
      ...(params.lowVolumeWarnCount === null ? {} : {'Low Volume Warn Count': params.lowVolumeWarnCount}),
      ...(params.lowVolumeErrorCount === null ? {} : {'Low Volume Error Count': params.lowVolumeErrorCount}),
      // How many times the user pressed Dismiss on the low-volume error toast during the recording.
      ...(params.lowVolumeErrorDismissCount === null ? {} : {'Low Volume Error Dismiss Count': params.lowVolumeErrorDismissCount}),
      // The recorder's MIME type, Title-Cased by word ("Audio/webm;codecs=opus").
      ...(params.codec === null ? {} : {'Codec': params.codec}),
      ...(params.stopReason === null ? {} : {'Stop Reason': params.stopReason}),
      // The meeting app the recording was last bound to (Zoom, Teams, Chrome, …), Title-Cased; absent when it never
      // bound.
      ...(params.boundMeetingApp === null ? {} : {'Bound Meeting App': params.boundMeetingApp}),
      // Which meeting-capture card started the recording; only with Event Source Meeting Notification.
      ...(params.trigger === null ? {} : {'Trigger': params.trigger}),
    },
  }
}

/**
 * A recording starts; Record Audio is the matching end. Android fires once the microphone has started, so a mic start
 * that fails sends nothing; for device audio it fires once the capture service is started after the projection grant,
 * so a refused grant sends nothing but a later foreground refusal in the service still sends it. Pause and resume send
 * nothing. iOS fires from its recording library's did-start callback; web fires once the stream is acquired and the
 * recorder is running.
 */
export function startRecording(params: {
  noteId: NoteIdValue | null
  eventSource: RecordingEventSource | null
  mode: RecordingMode
  streamAcquisitionMs: number
  deviceAudio: boolean
  codec: string | null
  boundMeetingApp: string | null
  trigger: MeetingNotificationTrigger | null
}): GeneratedAnalyticsEvent<'Start Recording'> {
  return {
    name: 'Start Recording',
    properties: {
      // iOS omits the key when the recording library has no note id; Android always has one.
      ...(params.noteId === null ? {} : {'Note Id': analyticsTypeWires.noteId(params.noteId)}),
      ...(params.eventSource === null ? {} : {'Event Source': params.eventSource}),
      'Mode': params.mode,
      'Stream Acquisition Ms': params.streamAcquisitionMs,
      // Whether the machine's own output was being mixed in when the recorder started.
      'Device Audio': params.deviceAudio,
      // The recorder's MIME type, Title-Cased by word ("Audio/webm;codecs=opus").
      ...(params.codec === null ? {} : {'Codec': params.codec}),
      // The meeting app the recording is bound to at start, Title-Cased; usually absent, since binding happens later.
      ...(params.boundMeetingApp === null ? {} : {'Bound Meeting App': params.boundMeetingApp}),
      // Which meeting-capture card started the recording; only with Event Source Meeting Notification.
      ...(params.trigger === null ? {} : {'Trigger': params.trigger}),
    },
  }
}

/**
 * A flashcard rating tap. Deprecated 2026-09-14: a rating is reported as Answer Study Question with a Rating property,
 * which is what iOS and Android send; web keeps sending this event until its Answer Study Question carries Rating.
 */
export function rateFlashcard(params: {
  rating: FlashcardRatingName
}): GeneratedAnalyticsEvent<'Rate Flashcard'> {
  return {
    name: 'Rate Flashcard',
    properties: {
      'Rating': params.rating,
    },
  }
}

/**
 * One completed sign-in attempt, cancellations included. Android reports Success from LoginStateRepository once the
 * library has loaded (or at a clean library-load timeout), because a caller-side report raced the post-login teardown
 * and lost most real successes. Two Failures also come from LoginStateRepository: Library Load Failed, and Unknown when
 * the session ended before the library loaded. Every other Failure and Cancel comes from the rail that started the
 * attempt. iOS reports every outcome from its own sites. Web fires once from the login-complete page after the redirect
 * lands.
 */
export function signIn(params: {
  type: SignInProvider | null
  result: SignInResult
  isNewAccount: boolean | null
  splitScreenVariant: string
  authSurface: string
}): GeneratedAnalyticsEvent<'Sign In'> {
  return {
    name: 'Sign In',
    properties: {
      ...(params.type === null ? {} : {'Type': params.type}),
      'Result': params.result,
      // Mobile sends it on Success only and repeats it on every sign-in until the persona survey completes, where web
      // sends it every time — count unique users, not events.
      ...(params.isNewAccount === null ? {} : {'Is New Account': params.isNewAccount}),
      'Split Screen Variant': params.splitScreenVariant,
      'Auth Surface': params.authSurface,
    },
  }
}

/** Every time an onboarding v2 screen shows, paging back included. */
export function showOnboardingStep(params: {
  onboardingStep: OnboardingStep
  persona: OnboardingStepPersona | null
}): GeneratedAnalyticsEvent<'Show Onboarding Step'> {
  return {
    name: 'Show Onboarding Step',
    properties: {
      'Onboarding Step': params.onboardingStep,
      // Absent until a persona is picked.
      ...(params.persona === null ? {} : {'Persona': params.persona}),
    },
  }
}

/**
 * Every way off an onboarding v2 screen. Connect Calendar fires once the connect settles, with its Result; nothing
 * fires on the click itself.
 */
export function selectOnboardingStepAction(params: {
  onboardingStep: OnboardingStep
  persona: OnboardingStepPersona | null
  action: OnboardingStepAction
  result: OnboardingStepResult | null
}): GeneratedAnalyticsEvent<'Select Onboarding Step Action'> {
  return {
    name: 'Select Onboarding Step Action',
    properties: {
      'Onboarding Step': params.onboardingStep,
      ...(params.persona === null ? {} : {'Persona': params.persona}),
      'Action': params.action,
      // Absent on actions with no outcome, and on desktop's Allow Microphone when the OS permission status could not be
      // read.
      ...(params.result === null ? {} : {'Result': params.result}),
    },
  }
}

/**
 * Once, after the last onboarding v2 step. iOS sends it only when the v2 deck ran (iPhone), and Android only at the end
 * of its calendar-onboarding deck, before a student's course-setup step.
 */
export function completeOnboarding(params: {
  persona: OnboardingStepPersona | null
  calendarConnected: boolean
  microphoneGranted: boolean
}): GeneratedAnalyticsEvent<'Complete Onboarding'> {
  return {
    name: 'Complete Onboarding',
    properties: {
      ...(params.persona === null ? {} : {'Persona': params.persona}),
      'Calendar Connected': params.calendarConnected,
      'Microphone Granted': params.microphoneGranted,
    },
  }
}

/**
 * One appearance of the Coming up module, never a See more toggle. Counts the collapsed card, whatever the expansion
 * state. The denominator for the note-start event. Fires even when empty, since an empty module still occupies Home.
 */
export function viewComingUp(params: {
  eventsCount: number
  isEmpty: boolean
  eligibleEventsCount: number
  calendarHomeCopyVariant: CalendarHomeCopyVariant
}): GeneratedAnalyticsEvent<'View Coming Up'> {
  return {
    name: 'View Coming Up',
    properties: {
      'Events Count': params.eventsCount,
      'Is Empty': params.isEmpty,
      'Eligible Events Count': params.eligibleEventsCount,
      'Calendar Home Copy Variant': params.calendarHomeCopyVariant,
    },
  }
}

/**
 * A note is started for a Coming up event, from the Home card's row, the home-screen widget's row, or a meeting
 * reminder.
 */
export function startEventNote(params: {
  isExistingNote: boolean
  eventIsRecurring: boolean | null
  trigger: StartEventNoteTrigger
  captureEligible: boolean | null
  attendeeCountBucket: string | null
  hasMeetingLink: boolean | null
  durationBucket: string | null
}): GeneratedAnalyticsEvent<'Start Event Note'> {
  return {
    name: 'Start Event Note',
    properties: {
      // Android populates this only behind CALENDAR_EVENT_NOTES, which reopens the note already linked to the meeting;
      // with the flag off every start is a fresh note and it reads false.
      'Is Existing Note': params.isExistingNote,
      // Web omits it on a notification start whose event can't be resolved; the apps always send it.
      ...(params.eventIsRecurring === null ? {} : {'Event Is Recurring': params.eventIsRecurring}),
      'Trigger': params.trigger,
      ...(params.captureEligible === null ? {} : {'Capture Eligible': params.captureEligible}),
      // 0 | 1 | 2to5 | 6+
      ...(params.attendeeCountBucket === null ? {} : {'Attendee Count Bucket': params.attendeeCountBucket}),
      ...(params.hasMeetingLink === null ? {} : {'Has Meeting Link': params.hasMeetingLink}),
      // <=30m | 31to60m | 61to120m | >120m
      ...(params.durationBucket === null ? {} : {'Duration Bucket': params.durationBucket}),
    },
  }
}

/**
 * The meeting-capture card went up, after every suppression gate, wherever it was triggered. The denominator for Accept
 * and Dismiss Record Meeting Notification, and for Record Audio's Meeting Notification accepts.
 */
export function showRecordMeetingNotification(params: {
  trigger: MeetingNotificationTrigger
  lifecycle: DesktopLifecycle | null
  idleSeconds: number | null
  minutesFromStart: number | null
  relevanceGate: boolean
  relevanceBucket: string | null
  calendarEventShape: CalendarEventShape | null
}): GeneratedAnalyticsEvent<'Show Record Meeting Notification'> {
  return {
    name: 'Show Record Meeting Notification',
    properties: {
      'Trigger': params.trigger,
      // Where the app window was when the card went up. The card is its own always-on-top panel, so only Asleep, Locked
      // or a long idle mean it went unseen. Absent from older shells.
      ...(params.lifecycle === null ? {} : {'Lifecycle': params.lifecycle}),
      // How long the machine had been idle when the card went up. Absent from older shells.
      ...(params.idleSeconds === null ? {} : {'Idle Seconds': params.idleSeconds}),
      // Whole minutes from the meeting's start to the card, floored, so negative when it went up early. Rides with the
      // event shape, and is also absent when the shell reports no show time.
      ...(params.minutesFromStart === null ? {} : {'Minutes From Start': params.minutesFromStart}),
      // Whether the shell decided the card on the relevance model's prediction (app_meetingRelevanceGateEnabled) rather
      // than attendee count alone.
      'Relevance Gate': params.relevanceGate,
      // The relevance model's confidence the user wanted the card: Under25 | 25to49 | 50to74 | 75plus. Absent on the
      // unscheduled card, which has no meeting to score.
      ...(params.relevanceBucket === null ? {} : {'Relevance Bucket': params.relevanceBucket}),
      ...(params.calendarEventShape === null ? {} : calendarEventShapeProperties(params.calendarEventShape)),
    },
  }
}

/**
 * A meeting that earned the desktop shell's scheduled card came due without one. With Show on Trigger Scheduled it
 * completes the denominator: every meeting the card could have prompted for.
 */
export function missRecordMeetingNotification(params: {
  trigger: MeetingNotificationTrigger
  reason: MeetingNotificationMissReason
  relevanceGate: boolean
  relevanceBucket: string | null
  calendarEventShape: CalendarEventShape | null
}): GeneratedAnalyticsEvent<'Miss Record Meeting Notification'> {
  return {
    name: 'Miss Record Meeting Notification',
    properties: {
      // Always Scheduled; only the shell's scheduled trigger reports misses.
      'Trigger': params.trigger,
      'Reason': params.reason,
      // Whether the shell decided the card on the relevance model's prediction (app_meetingRelevanceGateEnabled) rather
      // than attendee count alone.
      'Relevance Gate': params.relevanceGate,
      // The relevance model's confidence the user wanted the card: Under25 | 25to49 | 50to74 | 75plus. Absent for a
      // meeting the model hadn't scored.
      ...(params.relevanceBucket === null ? {} : {'Relevance Bucket': params.relevanceBucket}),
      ...(params.calendarEventShape === null ? {} : calendarEventShapeProperties(params.calendarEventShape)),
    },
  }
}

/**
 * The main window took an accepted capture card, before every gate that can still stop the recording — unlike Record
 * Audio's Meeting Notification, which counts only accepts that recorded.
 */
export function acceptRecordMeetingNotification(params: {
  trigger: MeetingNotificationTrigger
  minutesFromStart: number | null
  relevanceGate: boolean
  relevanceBucket: string | null
  calendarEventShape: CalendarEventShape | null
}): GeneratedAnalyticsEvent<'Accept Record Meeting Notification'> {
  return {
    name: 'Accept Record Meeting Notification',
    properties: {
      'Trigger': params.trigger,
      // Whole minutes from the meeting's start to the card, floored, so negative when it went up early. Rides with the
      // event shape, and is also absent when the shell reports no show time.
      ...(params.minutesFromStart === null ? {} : {'Minutes From Start': params.minutesFromStart}),
      // Whether the shell decided the card on the relevance model's prediction (app_meetingRelevanceGateEnabled) rather
      // than attendee count alone.
      'Relevance Gate': params.relevanceGate,
      // The relevance model's confidence the user wanted the card: Under25 | 25to49 | 50to74 | 75plus. Absent on the
      // unscheduled card, which has no meeting to score.
      ...(params.relevanceBucket === null ? {} : {'Relevance Bucket': params.relevanceBucket}),
      ...(params.calendarEventShape === null ? {} : calendarEventShapeProperties(params.calendarEventShape)),
    },
  }
}

/**
 * A capture card ended without an accept, so Show = Accept + Dismiss. The informational recording-stopped card fires
 * neither Show nor this.
 */
export function dismissRecordMeetingNotification(params: {
  trigger: MeetingNotificationTrigger
  reason: MeetingNotificationDismissReason
  minutesFromStart: number | null
  relevanceGate: boolean
  relevanceBucket: string | null
  calendarEventShape: CalendarEventShape | null
}): GeneratedAnalyticsEvent<'Dismiss Record Meeting Notification'> {
  return {
    name: 'Dismiss Record Meeting Notification',
    properties: {
      'Trigger': params.trigger,
      'Reason': params.reason,
      // Whole minutes from the meeting's start to the card, floored, so negative when it went up early. Rides with the
      // event shape, and is also absent when the shell reports no show time.
      ...(params.minutesFromStart === null ? {} : {'Minutes From Start': params.minutesFromStart}),
      // Whether the shell decided the card on the relevance model's prediction (app_meetingRelevanceGateEnabled) rather
      // than attendee count alone.
      'Relevance Gate': params.relevanceGate,
      // The relevance model's confidence the user wanted the card: Under25 | 25to49 | 50to74 | 75plus. Absent on the
      // unscheduled card, which has no meeting to score.
      ...(params.relevanceBucket === null ? {} : {'Relevance Bucket': params.relevanceBucket}),
      ...(params.calendarEventShape === null ? {} : calendarEventShapeProperties(params.calendarEventShape)),
    },
  }
}

/**
 * The "Join now" toast went up on a note opened for a calendar event with a join link, while the meeting is about to
 * start or under way. The denominator for Join Meeting From Toast.
 */
export function showJoinMeetingToast(): GeneratedAnalyticsEvent<'Show Join Meeting Toast'> {
  return {
    name: 'Show Join Meeting Toast',
    properties: {},
  }
}

/** The user took the "Join now" toast's button, opening the meeting link. */
export function joinMeetingFromToast(): GeneratedAnalyticsEvent<'Join Meeting From Toast'> {
  return {
    name: 'Join Meeting From Toast',
    properties: {},
  }
}

/**
 * The user asked to stop or resume reminders for one meeting, every occurrence of it where it recurs. Web sends it from
 * the bell on a Manage events or Coming up row and from the desktop card's stop-notifying menu; Android sends it from
 * the Coming up row's long-press menu and from the reminder notification's own action. The card's menu and the
 * notification's action can only silence, so they never report Enabled true.
 */
export function toggleMeetingNotification(params: {
  enabled: boolean
  decidedBy: MeetingNotificationDecider
  eventSource: MeetingNotificationToggleSource
  reason: MeetingNotificationMuteReason | null
  calendarEventShape: CalendarEventShape | null
}): GeneratedAnalyticsEvent<'Toggle Meeting Notification'> {
  return {
    name: 'Toggle Meeting Notification',
    properties: {
      'Enabled': params.enabled,
      // Whose verdict the user overrode, so corrections of the model read apart from the rule's and from users changing
      // their own minds.
      'Decided By': params.decidedBy,
      'Event Source': params.eventSource,
      // The menu pick. Absent for the bell, which asks no reason.
      ...(params.reason === null ? {} : {'Reason': params.reason}),
      ...(params.calendarEventShape === null ? {} : calendarEventShapeProperties(params.calendarEventShape)),
    },
  }
}

/**
 * A calendar is checked or unchecked in the settings picker. Deliberately carries no calendar name or id — they can be
 * workplace calendars.
 */
export function toggleCalendarSource(params: {
  enabled: boolean
  source: CalendarToggleSource
}): GeneratedAnalyticsEvent<'Toggle Calendar Source'> {
  return {
    name: 'Toggle Calendar Source',
    properties: {
      'Enabled': params.enabled,
      'Source': params.source,
    },
  }
}

/**
 * A calendar connect starts, before any consent UI. On desktop, fired by the browser leg of the handoff, not the shell.
 */
export function beginCalendarImport(params: {
  eventSource: CalendarConnectEventSource
  calendarProvider: CalendarProvider
  consentScope: CalendarConsentScope | null
  calendarHandoffAttempt: CalendarHandoffAttempt
}): GeneratedAnalyticsEvent<'Begin Calendar Import'> {
  return {
    name: 'Begin Calendar Import',
    properties: {
      'Event Source': params.eventSource,
      // The provider being connected. iOS also registers a Calendar Provider super property (the connected provider);
      // the event's own value wins on this event, which is the intent.
      'Calendar Provider': params.calendarProvider,
      ...(params.consentScope === null ? {} : {'Consent Scope': params.consentScope}),
      ...calendarHandoffAttemptProperties(params.calendarHandoffAttempt),
    },
  }
}

/** The provider's consent popup or redirect is about to open. */
export function openCalendarAuthenticationWindow(params: {
  calendarProvider: CalendarProvider
  consentScope: CalendarConsentScope | null
  calendarHandoffAttempt: CalendarHandoffAttempt
}): GeneratedAnalyticsEvent<'Open Calendar Authentication Window'> {
  return {
    name: 'Open Calendar Authentication Window',
    properties: {
      'Calendar Provider': params.calendarProvider,
      ...(params.consentScope === null ? {} : {'Consent Scope': params.consentScope}),
      ...calendarHandoffAttemptProperties(params.calendarHandoffAttempt),
    },
  }
}

/**
 * A connect ends without a connection: the consent popup was closed or refused (Reason is the popup's own error kind,
 * e.g. Popup Closed, Access Denied), or the server code exchange failed (Reason Exchange Failed). A closed popup is a
 * Fail, not silence.
 */
export function failCalendarAuthentication(params: {
  reason: string
  serverErrorKey: string | null
  eventSource: CalendarConnectEventSource
  calendarProvider: CalendarProvider
  consentScope: CalendarConsentScope | null
  calendarHandoffAttempt: CalendarHandoffAttempt
}): GeneratedAnalyticsEvent<'Fail Calendar Authentication'> {
  return {
    name: 'Fail Calendar Authentication',
    properties: {
      // Open-ended; web Title-Cases the provider's error kind (popup_closed → Popup Closed). iOS sends Popup Closed
      // (Google or Microsoft sheet cancelled), Exchange Failed, Microsoft's consent-page error Title-Cased as web does
      // (access_denied → Access Denied, or Microsoft Auth No Code when it sent none), Connect Failed (any other Google
      // or Microsoft error), Access Denied (Apple permission prompt refused) and Opened Settings (Apple access denied
      // earlier, so the user was sent to iOS Settings). Android sends its own three shapes: Denied, Redirected To
      // Settings and Dismissed.
      'Reason': params.reason,
      ...(params.serverErrorKey === null ? {} : {'Server Error Key': params.serverErrorKey}),
      'Event Source': params.eventSource,
      'Calendar Provider': params.calendarProvider,
      ...(params.consentScope === null ? {} : {'Consent Scope': params.consentScope}),
      ...calendarHandoffAttemptProperties(params.calendarHandoffAttempt),
    },
  }
}

/**
 * A connect landed and the follow-up event fetch settled. The API server also sends this event itself for a desktop
 * Google sign-in that granted calendar (Event Source Sign In), from hand-written code in services/api.
 */
export function completeCalendarAuthentication(params: {
  detectedEventsCount: number
  eventsFetchFailed: boolean
  eventSource: CalendarConnectEventSource
  calendarProvider: CalendarProvider
  calendarCount: number
  secondaryEventsCount: number
  recurringGroupsCount: number
  skippedCalendarCount: number | null
  calendarListStatus: CalendarListStatus | null
  calendarListScope: CalendarListScope | null
  consentScope: CalendarConsentScope | null
  calendarHandoffAttempt: CalendarHandoffAttempt
}): GeneratedAnalyticsEvent<'Complete Calendar Authentication'> {
  return {
    name: 'Complete Calendar Authentication',
    properties: {
      // Raw synced events, before any grouping or detection; 0 when the post-auth fetch fails.
      'Detected Events Count': params.detectedEventsCount,
      // Auth succeeded but the follow-up event fetch failed; without it a failed connect counts as a successful
      // zero-event one.
      'Events Fetch Failed': params.eventsFetchFailed,
      'Event Source': params.eventSource,
      'Calendar Provider': params.calendarProvider,
      // Calendars the events came from; 1 when only the primary is read, 0 when the fetch failed. iOS's Apple connect
      // counts only calendars with an event in the window, so an empty calendar never counts there; iOS's Microsoft
      // connect reads one calendar, so it is 1 whenever the fetch succeeds.
      'Calendar Count': params.calendarCount,
      'Secondary Events Count': params.secondaryEventsCount,
      'Recurring Groups Count': params.recurringGroupsCount,
      ...(params.skippedCalendarCount === null ? {} : {'Skipped Calendar Count': params.skippedCalendarCount}),
      ...(params.calendarListStatus === null ? {} : {'Calendar List Status': params.calendarListStatus}),
      ...(params.calendarListScope === null ? {} : {'Calendar List Scope': params.calendarListScope}),
      ...(params.consentScope === null ? {} : {'Consent Scope': params.consentScope}),
      ...calendarHandoffAttemptProperties(params.calendarHandoffAttempt),
    },
  }
}

/** A browser-leg connect actually landed in the desktop shell. */
export function completeDesktopCalendarHandoff(params: {
  calendarProvider: CalendarProvider
  handoffId: string | null
  eventSource: CalendarConnectEventSource | null
}): GeneratedAnalyticsEvent<'Complete Desktop Calendar Handoff'> {
  return {
    name: 'Complete Desktop Calendar Handoff',
    properties: {
      'Calendar Provider': params.calendarProvider,
      ...(params.handoffId === null ? {} : {'Handoff Id': params.handoffId}),
      ...(params.eventSource === null ? {} : {'Event Source': params.eventSource}),
    },
  }
}

/** The shell settled a handoff without a connection. */
export function failDesktopCalendarHandoff(params: {
  reason: CalendarHandoffFailReason
  handoffId: string | null
  eventSource: CalendarConnectEventSource | null
}): GeneratedAnalyticsEvent<'Fail Desktop Calendar Handoff'> {
  return {
    name: 'Fail Desktop Calendar Handoff',
    properties: {
      'Reason': params.reason,
      ...(params.handoffId === null ? {} : {'Handoff Id': params.handoffId}),
      ...(params.eventSource === null ? {} : {'Event Source': params.eventSource}),
    },
  }
}

/** The handoff's browser leg is signed into a different account than the shell; consent never ran. */
export function showCalendarAccountMismatch(params: {
  handoffId: string | null
  eventSource: CalendarConnectEventSource | null
}): GeneratedAnalyticsEvent<'Show Calendar Account Mismatch'> {
  return {
    name: 'Show Calendar Account Mismatch',
    properties: {
      ...(params.handoffId === null ? {} : {'Handoff Id': params.handoffId}),
      ...(params.eventSource === null ? {} : {'Event Source': params.eventSource}),
    },
  }
}

/** A user-initiated calendar sync settles. */
export function syncCalendar(params: {
  outcome: SyncCalendarOutcome
  source: SyncCalendarSource
  eventsCount: number | null
}): GeneratedAnalyticsEvent<'Sync Calendar'> {
  return {
    name: 'Sync Calendar',
    properties: {
      'Outcome': params.outcome,
      // Absent on events from older versions.
      'Source': params.source,
      ...(params.eventsCount === null ? {} : {'Events Count': params.eventsCount}),
    },
  }
}

/**
 * A connect prompt on Home appears: web's connect card, iOS's unlock card, Android's calendar-connect card, or
 * desktop's Coming up re-consent prompt. The denominator for Begin Calendar Import with Event Source Home Screen.
 */
export function showCalendarConnectCard(params: {
  reason: CalendarConnectCardReason
}): GeneratedAnalyticsEvent<'Show Calendar Connect Card'> {
  return {
    name: 'Show Calendar Connect Card',
    properties: {
      // Absent on events from builds before re-consent existed.
      'Reason': params.reason,
    },
  }
}

/**
 * An error card in Coming up appears, once per mount. Separate from Show Calendar Connect Card so that event counts
 * connect prompts alone; Load Failed is the denominator for Sync Calendar with Source Coming Up Retry.
 */
export function showCalendarErrorCard(params: {
  kind: CalendarErrorCardKind
}): GeneratedAnalyticsEvent<'Show Calendar Error Card'> {
  return {
    name: 'Show Calendar Error Card',
    properties: {
      'Kind': params.kind,
    },
  }
}

/** The calendar link prompt opens. The denominator for Connect Calendar Link from the same Source. */
export function viewCalendarLinkPrompt(params: {
  source: CalendarLinkSource
}): GeneratedAnalyticsEvent<'View Calendar Link Prompt'> {
  return {
    name: 'View Calendar Link Prompt',
    properties: {
      'Source': params.source,
    },
  }
}

/**
 * A calendar link connect settles, or the prompt closes without a submit (Result Cancelled). Calendar links fire none
 * of the Begin / Complete Calendar Import funnel events.
 */
export function connectCalendarLink(params: {
  result: CalendarLinkResult
  source: CalendarLinkSource
  failureReason: CalendarLinkFailureReason | null
  feedHost: string | null
  eventsCount: number | null
}): GeneratedAnalyticsEvent<'Connect Calendar Link'> {
  return {
    name: 'Connect Calendar Link',
    properties: {
      'Result': params.result,
      'Source': params.source,
      // Sent only with Result Failed.
      ...(params.failureReason === null ? {} : {'Failure Reason': params.failureReason}),
      // The link's lowercased host, never its path or query, which hold the feed's secret. Absent on Cancelled, on a
      // link too malformed to have a host, and on a failed paste with no scheme, which may be a downloaded file named
      // after the secret.
      ...(params.feedHost === null ? {} : {'Feed Host': params.feedHost}),
      // Sent only with Result Connected.
      ...(params.eventsCount === null ? {} : {'Events Count': params.eventsCount}),
    },
  }
}

/**
 * The desktop calendar gate shows a stage, or changes whether it offers "No calendar" within one, or the test arm's "No
 * calendar" opens its add-events screen (Stage Add Events), so a connect-then-no-events session reports two. iOS: the
 * onboarding calendar step shows with no calendar connected (Stage Connect, each time the step shows), or a
 * calendar-first Home card shows a stage, once per stage per launch. The denominator for Skip Calendar Gate and for
 * Begin Calendar Import with Event Source Calendar Gate.
 */
export function showCalendarGate(params: {
  offersNoCalendar: boolean
  skipReason: CalendarGateSkipReason | null
  stage: CalendarGateStage
}): GeneratedAnalyticsEvent<'Show Calendar Gate'> {
  return {
    name: 'Show Calendar Gate',
    properties: {
      // The connect screen offers at most "No calendar" (see Offers No Calendar); outside the
      // app_desktopSsoTryConnectBeforeSkip test arm, Later shows only past it (see Stage). Older events carry Everyone,
      // New And Existing Users or Existing Users Only, which gated Skip differently.
      'Skip Policy': 'No Calendar Only',
      // Whether this screen drew "I don't have a calendar". On desktop, false only in the
      // app_desktopSsoTryConnectBeforeSkip test arm: a non-student calendar-SSO connect screen, and the Add Events
      // screen. On iOS, false where Try another way (the syllabus option) takes its place, and on the Home card's Add
      // Events and Connect Failed stages. Absent on builds that predate it.
      'Offers No Calendar': params.offersNoCalendar,
      // What Skip Calendar Gate would carry; set on every stage, Connect included.
      ...(params.skipReason === null ? {} : {'Skip Reason': params.skipReason}),
      'Stage': params.stage,
    },
  }
}

/**
 * The user passes the desktop calendar gate or the iOS onboarding calendar step without connecting, through Later or "I
 * don't have a calendar", or picks "I don't use a calendar" / "Try another way" on a Home calendar card. iOS's Next on
 * an already-connected calendar is not a skip and sends none.
 */
export function skipCalendarGate(params: {
  reason: CalendarGateSkipReason
  action: OnboardingStepAction
  stage: CalendarGateStage
}): GeneratedAnalyticsEvent<'Skip Calendar Gate'> {
  return {
    name: 'Skip Calendar Gate',
    properties: {
      'Reason': params.reason,
      // The button pressed, Later or No Calendar. Absent on builds that predate it.
      'Action': params.action,
      // The gate's screen, or on Home the card: Connect for no calendar, No Events for a connected calendar with
      // nothing upcoming. iOS's onboarding step is always Connect. Absent on builds that predate it.
      'Stage': params.stage,
    },
  }
}

/** The user adds a custom event from the gate's no-events prompt or the Manage events modal. */
export function addCustomCalendarEvent(params: {
  eventSource: CustomCalendarEventSource
}): GeneratedAnalyticsEvent<'Add Custom Calendar Event'> {
  return {
    name: 'Add Custom Calendar Event',
    properties: {
      'Event Source': params.eventSource,
    },
  }
}

/**
 * The user confirms the gate's no-events prompt or saves the Manage events modal. Open Modal with Modal Type Calendar
 * Events is the modal's denominator.
 */
export function saveCalendarEvents(params: {
  eventsCount: number
}): GeneratedAnalyticsEvent<'Save Calendar Events'> {
  return {
    name: 'Save Calendar Events',
    properties: {
      // Grouped events (detected and custom) the user left selected when confirming.
      'Events Count': params.eventsCount,
    },
  }
}

/**
 * The first-run cue card over Coming up appears, once per card per launch. The denominator for Dismiss Calendar Cue
 * Card.
 */
export function showCalendarCueCard(params: {
  cueCard: CalendarCueCard
}): GeneratedAnalyticsEvent<'Show Calendar Cue Card'> {
  return {
    name: 'Show Calendar Cue Card',
    properties: {
      'Cue Card': params.cueCard,
    },
  }
}

/** The first-run cue card over Coming up is retired, counted only against an impression. */
export function dismissCalendarCueCard(params: {
  cueCard: CalendarCueCard
  eventSource: DismissCalendarCueCardSource
}): GeneratedAnalyticsEvent<'Dismiss Calendar Cue Card'> {
  return {
    name: 'Dismiss Calendar Cue Card',
    properties: {
      'Cue Card': params.cueCard,
      'Event Source': params.eventSource,
    },
  }
}

/**
 * A Connect row for an AI app is tapped, handing the user to that app's connector settings. The app finishes the
 * connection, so this is the top of the funnel, not a completed connection.
 */
export function beginAIAppConnection(params: {
  aiApp: AiApp
  eventSource: AiAppConnectionEventSource
}): GeneratedAnalyticsEvent<'Begin AI App Connection'> {
  return {
    name: 'Begin AI App Connection',
    properties: {
      'AI App': params.aiApp,
      'Event Source': params.eventSource,
    },
  }
}
